const LogoMark = ({ size = 38, testId = "logo-mark" }) => (
  <img
    src="/logo-commpaq.png"
    alt="COMMPAQ"
    width={size}
    height={size}
    data-testid={testId}
    className="rounded-xl"
  />
);

export default LogoMark;
